import "./index.css";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider, ErrorBoundary } from "@rollbar/react";
import { routeTree } from "./routeTree.gen";
import { Toaster } from "./components/ui/toaster";
import { TooltipProvider } from "./components/ui/tooltip";
import { AuthProvider } from "./providers/AuthProvider";
import { PostHogProvider } from "posthog-js/react"
import DefaultErrorComponent from "./layouts/error";
import { QueryClientProvider } from "@tanstack/react-query";
import { TransportProvider } from "@connectrpc/connect-query";
import { queryClient, transport } from "./connect";
import { Loading } from "./layouts/loading";

const router = createRouter({
  routeTree,
  defaultPendingComponent: Loading,
  defaultPreload: "intent",
  defaultErrorComponent: DefaultErrorComponent,
  context: {
    queryClient,
  }
});

const container = document.getElementById("root");

if (container === null) {
  throw new Error("app element does not exists.");
}


createRoot(container).render(
  <StrictMode>
    <TransportProvider transport={transport}>
      <QueryClientProvider client={queryClient}>
        <Provider
          config={{
            accessToken: "78bfb0f7d89e400487b49f4795130cfd",
            environment: process.env.NODE_ENV || "development",
            captureDeviceInfo: true,
            captureIp: true,
            captureUnhandledRejections: true,
            captureUncaught: true,
            enabled: process.env.NODE_ENV === "production",
            payload: {
              client: {
                javascript: {
                  code_version: import.meta.env.VITE_APP_VERSION,
                  source_map_enabled: true,
                  guess_uncaught_frames: true
                }
              }
            }
          }}
        >
          <ErrorBoundary>
              <AuthProvider>
                <Toaster />
                <TooltipProvider>
                  <PostHogProvider
                    apiKey={import.meta.env.VITE_POSTHOG_KEY}
                    options={{
                      api_host: import.meta.env.VITE_POSTHOG_HOST
                    }}
                  >
                    <RouterProvider router={router} />
                  </PostHogProvider>
                </TooltipProvider>
              </AuthProvider>
          </ErrorBoundary>
        </Provider>
      </QueryClientProvider>
    </TransportProvider>
  </StrictMode>
);
